import { __spreadArray as e } from "tslib";
var r = ["birthdate", "email", "family_name", "given_name", "middle_name", "name", "nickname", "phone_number", "preferred_username", "profile", "website"],
    a = ["address", "gender", "locale", "picture", "updated_at", "zoneinfo"],
    n = ["username", "email", "phone_number"],
    m = e(e(e([], n, !0), r, !0), ["confirmation_code", "password", "confirm_password"], !1);
export { n as LoginMechanismArray, m as authFieldsWithDefaults, r as signUpFieldsWithDefault, a as signUpFieldsWithoutDefault };